import { cva } from 'class-variance-authority';

export const avatarStyles = cva('relative shrink-0 rounded-full', {
  variants: {
    size: {
      small: 'h-8 w-8',
      medium: 'h-10 w-10',
    },
  },
  defaultVariants: {
    size: 'small',
  },
});

export const avatarInitialsStyles = cva(
  'flex h-full w-full items-center justify-center overflow-hidden rounded-full bg-grey-200 bg-cover bg-center font-inter font-medium text-grey-700',
  {
    variants: {
      size: {
        small: 'text-xs',
        medium: 'text-sm',
      },
    },
    defaultVariants: {
      size: 'small',
    },
  }
);
